var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import ReactTooltip from 'react-tooltip';
import { styled } from 'styled-components';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
var ScReactTooltip = styled(ReactTooltip).withConfig({ displayName: "ScReactTooltip", componentId: "sc-4t4lg4" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 253px;\n  background-color: #ffffff;\n  opacity: 1 !important;\n  will-change: filter;\n  filter: drop-shadow(0px 4px 28px rgba(0, 0, 0, 0.14));\n  font-size: 13px;\n  line-height: 24px;\n  letter-spacing: -0.2px;\n  color: ", ";\n"], ["\n  width: 253px;\n  background-color: #ffffff;\n  opacity: 1 !important;\n  will-change: filter;\n  filter: drop-shadow(0px 4px 28px rgba(0, 0, 0, 0.14));\n  font-size: 13px;\n  line-height: 24px;\n  letter-spacing: -0.2px;\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.blackText;
});
var Tooltip = function (props) {
    useEffect(function () {
        ReactTooltip.rebuild();
    }, []);
    return (_jsx(ScReactTooltip, __assign({ multiline: true, effect: 'solid', type: 'light', delayHide: 200, arrowColor: '#fff' }, props), void 0));
};
export { Tooltip };
var templateObject_1;
